import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54039fd3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#AAABAC","letter-spacing":"0.150rem"} }, "S O L U T I O N", -1))
const _hoisted_3 = {
  class: "title",
  style: {"display":"flex","align-items":"center","color":"#000","letter-spacing":"0.4rem","margin":"7px 0"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("解 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("决 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("方 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("案 ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "desc",
  style: {"color":"#AAABAC"}
}, "满足不同场景业务需求，助力企业数字化转型", -1))
const _hoisted_9 = {
  class: "container",
  ref: "container"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "image-font-f"
}
const _hoisted_12 = {
  class: "textf1",
  style: {"color":"#000","font-size":"2rem"}
}
const _hoisted_13 = {
  class: "textf2",
  style: {"color":"#9FB2D2","margin-top":".66rem","letter-spacing":"1.5px"}
}
const _hoisted_14 = {
  key: 1,
  class: "image-font-t"
}
const _hoisted_15 = {
  class: "textt1",
  style: {"color":"#002864","font-size":"4.5rem"}
}
const _hoisted_16 = {
  class: "textt2",
  style: {"color":"#A1A9BA","margin":"1.5rem 0","font-size":"1.5vw","letter-spacing":"2px"}
}
const _hoisted_17 = {
  class: "textt3",
  style: {"color":"#002864","white-space":"pre-wrap","font-size":"1.5rem"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#7FA6D0","font-weight":"900","margin-top":"1.7rem"} }, "━━━", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sapn = _resolveComponent("sapn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_sapn, { class: "shu" }),
        _hoisted_5,
        _createVNode(_component_sapn, { class: "shu" }),
        _hoisted_6,
        _createVNode(_component_sapn, { class: "shu" }),
        _hoisted_7
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["rectangle", { clicked: item.clicked }]),
          key: index,
          style: _normalizeStyle({ width: item.width, }),
          onClick: ($event: any) => ($setup.toggleClick(index))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["image", { small: !item.clicked, big: item.clicked }])
          }, [
            (item.clicked == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.entitle), 1)
                ]))
              : _createCommentVNode("", true),
            (item.clicked == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.entitle), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.description), 1),
                  _hoisted_18
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 14, _hoisted_10))
      }), 128))
    ], 512)
  ], 64))
}